export const styles = {
  line: {
    width: '2px',
    height: '30px',
    backgroundColor: 'rgba(0, 0, 0, .2)',
  },
  popupItem: { fontSize: '10px', color: '#7C7C7C' },
  wrapperInput: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    borderBottom: '1px solid #c4c4c4',
    paddingLeft: '24px',
    '&:first-child': {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  wrapperSelect: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: '10px',
    marginBottom: '10px',
    paddingLeft: '24px',
    minWidth: '590px',
  },
  select: {
    '& .MuiSelect-select': {
      marginLeft: '10px',
      fontSize: '12px',
      color: '#7F8FA4',
      paddingTop: '4px',
      paddingBottom: '4px',
      border: '1px solid gray',
    },
    '&:invalid': {
      border: '1px solid red',
    },
  },
  selectError: {
    '& .MuiSelect-select': {
      marginLeft: '10px',
      fontSize: '12px',
      color: '#7F8FA4',
      border: '1px solid red',
      paddingTop: '4px',
      paddingBottom: '4px',
    },
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: '4px',
    borderBottom: '1px solid #c4c4c4',
    paddingBottom: '8px',
    paddingLeft: '24px',
  },
  button: {
    fontSize: '12px !important',
    color: '#7F8FA4 !important',
    textTransform: 'none',
    boxShadow: '0px 0px 10px white',
    width: '100%',
  },
  disabledButton: {
    fontSize: '12px !important',
    color: '#FCFCFC !important',
    backgroundColor: '#E6E6E6 !important',
    textTransform: 'none',
    boxShadow: '0px 0px 10px white',
    width: '100%',
  },
  header: {
    width: '620px',
    height: '30px',
    backgroundColor: '#273754',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontWeight: '600',
    color: '#FFFFFF',
    borderRadius: '10px 10px 0 0',
    paddingLeft: '28px',
  },
  body: {
    display: 'flex',
    flex: '1',
    flexDirection: 'column',
    width: '620px',
    boxShadow: '0px 4px 4px 0px #b8b8b8',
    borderRadius: '0 0 4px 4px',
  },
  comparisonIcon: {
    paddingRight: '8px',
    fontSize: '14px',
    color: '#7F8FA4',
  },
  menuItem: {
    fontSize: '12px',
  },
  smallInput: {
    '& .MuiInputBase-input': {
      width: '50px',
      height: '15px',
      marginLeft: '10px',
      fontSize: '12px',
      color: '#7F8FA4',
      border: '1px solid #c4c4c4',
    },
  },
  smallInputError: {
    '& .MuiInputBase-input': {
      width: '50px',
      height: '15px',
      marginLeft: '10px',
      fontSize: '12px',
      color: '#7F8FA4',
      border: '1px solid red',
    },
  },
  input: {
    '& .MuiInputBase-input': {
      marginLeft: '10px',
      height: '20px',
      fontSize: '12px',
    },
  },
  buttonWrap: { display: 'flex', justifyContent: 'center' },
  textArea: {
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px 24px',
    },
  },
}
